import { SVGProps } from "react"
const RightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#97A0AF"
      d="M8.9 8 5 4.1a.948.948 0 0 1-.275-.7c0-.283.091-.516.275-.7a.948.948 0 0 1 .7-.274c.283 0 .516.091.7.275L11 7.3c.1.1.17.208.213.325a1.15 1.15 0 0 1 0 .75A.851.851 0 0 1 11 8.7l-4.6 4.6a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.284.091-.517.275-.7L8.9 8Z"
    />
  </svg>
)
export default RightArrow
